import { ViewModel } from "../../settings/viewModel";
import { PlotDefinition, ChartType } from "../../definitions";
import { DataProperty, Scenario } from "../../library/constants";
import { HorizontalPlotter } from "./horizontalPlotter";

export class ActualTablePlotter extends HorizontalPlotter {
    constructor(
        viewModel: ViewModel,
        width: number,
        height: number,
        reportArea: d3.Selection<SVGElement, any, any, any>,
        svg: d3.Selection<SVGElement, any, any, any>,
        locale: string
    ) {
        super(viewModel, width, height, reportArea, svg, locale);
    }

    protected getPlotDefinition(): PlotDefinition {
        let plotDefinition = this.getBlankPlotDefinition(0);
        if (this.viewModel.HasReferenceColumn && this.viewModel.reference.scenario === Scenario.PreviousYear) {
            this.addChartDefinition(
                plotDefinition,
                ChartType.Table,
                DataProperty.ReferenceValue,
                DataProperty.ReferenceValue,
                false,
                false
            );
        }
        if (this.viewModel.HasValueColumn) {
            this.addChartDefinition(plotDefinition, ChartType.Table, DataProperty.Value, DataProperty.ReferenceValue, false, false);
        }
        if (this.viewModel.HasReferenceColumn && this.viewModel.reference.scenario !== Scenario.PreviousYear) {
            this.addChartDefinition(
                plotDefinition,
                ChartType.Table,
                DataProperty.ReferenceValue,
                DataProperty.ReferenceValue,
                false,
                false
            );
        }
        if (this.viewModel.HasSecondReferenceColumn) {
            this.addChartDefinition(
                plotDefinition,
                ChartType.Table,
                DataProperty.SecondReferenceValue,
                DataProperty.ReferenceValue,
                false,
                false
            );
        }
        if (this.viewModel.HasThirdReferenceColumn) {
            this.addChartDefinition(
                plotDefinition,
                ChartType.Table,
                DataProperty.ThirdReferenceValue,
                DataProperty.ReferenceValue,
                false,
                false
            );
        }
        if (this.viewModel.HasFourthReferenceColumn) {
            this.addChartDefinition(
                plotDefinition,
                ChartType.Table,
                DataProperty.FourthReferenceValue,
                DataProperty.ReferenceValue,
                false,
                false
            );
        }
        if (this.viewModel.HasFifthReferenceColumn) {
            this.addChartDefinition(
                plotDefinition,
                ChartType.Table,
                DataProperty.FifthReferenceValue,
                DataProperty.ReferenceValue,
                false,
                false
            );
        }
        if (this.viewModel.HasSixthReferenceColumn) {
            this.addChartDefinition(
                plotDefinition,
                ChartType.Table,
                DataProperty.SixthReferenceValue,
                DataProperty.ReferenceValue,
                false,
                false
            );
        }
        if (this.viewModel.HasSeventhReferenceColumn) {
            this.addChartDefinition(
                plotDefinition,
                ChartType.Table,
                DataProperty.SeventhReferenceValue,
                DataProperty.ReferenceValue,
                false,
                false
            );
        }
        return plotDefinition;
    }
}
